<template>
   <v-container fluid class="e-min-height pa-0 primary-gradiente" >
    <HeaderFill :back="false" title="Práctica Intermedia" :router="`/practica/intermedio/${this.idUnidad}`" />
    <v-container style="padding-top: 62px;">
      <v-layout row wrap class="fill-height">
        <v-flex xs12>
          <router-view></router-view>
        </v-flex>
      </v-layout>
    </v-container>
  </v-container>
</template>
<script>
export default {
  props: ['idUnidad']
}
</script>

